module.exports = __webpack_public_path__ + "img/facebook.b52a0226.svg";